import { render, staticRenderFns } from "./sa-500.vue?vue&type=template&id=7513602c&scoped=true&"
import script from "./sa-500.vue?vue&type=script&lang=js&"
export * from "./sa-500.vue?vue&type=script&lang=js&"
import style0 from "./sa-500.vue?vue&type=style&index=0&id=7513602c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7513602c",
  null
  
)

export default component.exports